<template>
  <Popover class="relative">
    <Float placement="bottom-end" :offset="4" portal>
      <PopoverButton
        class="inline-flex items-center justify-between gap-3 rounded-md border border-slate-300 bg-white px-3 py-2 font-medium text-gray-600 dark:bg-slate-700 dark:text-gray-300"
      >
        <span class="text-xs font-medium capitalize-first">
          {{ $t('button.column') }}
        </span>
        <FontAwesomeIcon :icon="['fal', 'chevron-down']" />
      </PopoverButton>
      <PopoverPanel
        class="z-50 rounded-md bg-white p-2 shadow-lg ring-1 ring-black/5 dark:bg-slate-800"
      >
        <button
          v-for="column in columns.filter((item) => item.toggleable !== false)"
          :key="column.field"
          type="button"
          class="flex w-full items-center gap-5 rounded-md p-2 text-left hover:bg-gray-100 dark:hover:bg-slate-700"
          @click="toggle(column.field)"
        >
          <span class="flex-1 whitespace-nowrap capitalize-first">
            {{ $t(`attributes.${column.title}`) }}
          </span>
          <span
            class="relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200"
            :class="column.hidden ? 'bg-gray-200' : 'bg-primary-500'"
          >
            <span
              class="inline-block h-5 w-5 transform rounded-full bg-white shadow transition duration-200"
              :class="column.hidden ? 'translate-x-0' : 'translate-x-5'"
            />
          </span>
        </button>
      </PopoverPanel>
    </Float>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Column visibility menu of the invoicing tables. `v-model` is the column
 * list; toggling flips `hidden` and stores the list in localStorage
 * (`InvoiceColumnsVisibility`), as the former package did.
 */
export default {
  name: 'ColumnVisibilityDropDownComponent',
  components: { Popover, PopoverButton, PopoverPanel, Float, FontAwesomeIcon },
  props: {
    modelValue: { type: Array, required: true }
  },
  emits: ['update:modelValue'],
  computed: {
    columns() {
      return this.modelValue ?? []
    }
  },
  methods: {
    toggle(field) {
      const columns = this.columns.map((column) =>
        column.field === field ? { ...column, hidden: !column.hidden } : column
      )
      try {
        localStorage.setItem(
          'InvoiceColumnsVisibility',
          JSON.stringify(columns)
        )
      } catch (_) {}
      this.$emit('update:modelValue', columns)
    }
  }
}
</script>
